
import { Component, Input } from '@angular/core';

export type AlertType = 'INFO' | 'WARN' | 'DANGER' | 'SUCCESS' ;

@Component({
    selector: 'app-alert',
    imports: [],
    templateUrl: './alert.component.html',
    styleUrl: './alert.component.scss'
})
export class AlertComponent {

  @Input()
  type?: AlertType ;

  public get alertClass(): string | undefined {

    if (!this.type)
      return undefined ;

    switch (this.type) {
      case 'INFO':
        return 'alert-info';
      case 'WARN': 
        return 'alert-warn' ;
      case 'DANGER':
        return 'alert-danger';
      case 'SUCCESS':
        return 'alert-success';
    }
  }

}
